export default __webpack_public_path__ + "static/media/stanne.713cadd2.jpg";